var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDensityLogoMarkLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.414 1204.68C719.124 1162.09 779.239 1102.49 821.977 1031.55C866.744 957.24 892.457 870.495 892.457 777.824V448.107C892.457 430.736 906.751 416.667 924.399 416.667H1075.61C1093.24 416.667 1107.55 430.736 1107.55 448.107V777.824C1107.55 870.495 1133.25 957.24 1178.02 1031.55C1220.76 1102.48 1280.87 1162.09 1352.58 1204.68L1650.68 1374.08C1665.96 1382.77 1671.2 1402 1662.39 1417.03L1586.78 1545.93C1577.95 1560.96 1558.42 1566.12 1543.15 1557.44L1250.26 1390.99C1176.45 1349.59 1091.04 1325.93 1000.01 1325.93C908.971 1325.93 823.542 1349.59 749.74 1390.99L456.864 1557.44C441.58 1566.12 422.048 1560.96 413.232 1545.93L337.625 1417.03C328.793 1402 334.031 1382.77 349.316 1374.08L647.414 1204.68Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensityLogoMarkLight);
export default __webpack_public_path__ + "static/media/density-logo-mark-light.da82f5ee08f3197b940ee29c3d9f2d62.svg";
export { ForwardRef as ReactComponent };